import { put } from "redux-saga/effects";

import { UpdateUserMetadataResponse } from "redmond";
import { actions } from "../actions";
import { updateUserMetadata } from "../../../api/v0/user/updateUserMetadata";
import { vrAwarenessModalLocalStorageKey } from "./fetchHasSeenVRAwarenessSaga";

export function* updateHasSeenVRAwarenessSaga(
  action: actions.IUpdateHasSeenVRAwareness
) {
  try {
    const res: UpdateUserMetadataResponse = yield updateUserMetadata({
      userMetadata: {
        hasSeenStaysVrFtux: action.hasSeenVRAwareness,
      },
    });

    if (res.Response !== "Success") {
      throw new Error("Failed to update metadata");
    }

    if (action.hasSeenVRAwareness) {
      localStorage.setItem(vrAwarenessModalLocalStorageKey, "true");
    }
    yield put(actions.setHasSeenVRAwareness(action.hasSeenVRAwareness));
  } catch (e) {
    console.error(e);
    // Allow the modal to close if there was an error updating the metadata
    localStorage.setItem(vrAwarenessModalLocalStorageKey, "true");
    yield put(actions.setHasSeenVRAwareness(true));
  }
}
